






















/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-alert */
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class IntegrityProgressBar extends Vue {
  @Prop() label: string;

  uploadProgressPercent = '';

  startUploadTime = 0;

  estimatedTimeLeft = 0;

  loadedAmount = 0;

  loadedString = '';

  formattedEstimatedTime = '';

  fileUploading = false;

  totalBytes = 0;

  TimeConvertions = [
    {
      val: 1000,
      desc: 'seconds',
    },
    {
      val: 60,
      desc: 'minutes',
    },
    {
      val: 60,
      desc: 'hours',
    },
  ];

  sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  startUpload(): void {
    this.fileUploading = true;
    this.startUploadTime = Date.now();
  }

  completeProgressBar(): void {
    this.fileUploading = false;
    this.$emit('onFileUploaded');
  }

  updateProgressBar(uploadedBytes, totalBytes): void {
    if (uploadedBytes < this.loadedAmount || this.loadedAmount === 0) {
      this.startUpload();
    }

    // If there is no updated value, then dont bother updating other values
    if (this.loadedAmount === uploadedBytes && this.totalBytes === totalBytes) {
      return;
    }
    this.loadedAmount = uploadedBytes;
    this.totalBytes = totalBytes;

    let uploadProgress = uploadedBytes / this.totalBytes;
    if (Number.isNaN(uploadProgress)) {
      uploadProgress = 0;
    }

    if (uploadProgress >= 1) {
      this.completeProgressBar();
    }
    this.uploadProgressPercent = `${Math.round(100 * uploadProgress)} %`;
    const elaspedTime = Date.now() - this.startUploadTime;

    this.estimatedTimeLeft = uploadProgress === 0 ? null : elaspedTime * (1 / uploadProgress - 1);
    this.loadedString = this.importedValues;
    this.formattedEstimatedTime = this.getFormattedEstimatedTime();
  }

  getFormattedEstimatedTime(): string {
    if (!this.estimatedTimeLeft) {
      return '';
    }
    let convertedTimeLeft = this.estimatedTimeLeft;
    let convertionsIndex = 0;
    while (convertionsIndex < this.TimeConvertions.length) {
      const convertion = this.TimeConvertions[convertionsIndex];
      convertedTimeLeft /= convertion.val;
      if (convertedTimeLeft / convertion.val < 1) {
        break;
      }
      convertionsIndex += 1;
    }
    return `About ${Math.round(convertedTimeLeft)} ${
      this.TimeConvertions[convertionsIndex].desc
    } remaining`;
  }

  getFileSizeInMeasurement(bytes: number, sizeIndex: number): string {
    return `${(bytes / 1024 ** sizeIndex).toFixed(1)}`;
  }

  get importedValues(): string {
    const convertionValue = 1024;
    const bytes = this.totalBytes ?? 0;
    const convertionIndex = Math.floor(
      Math.log(bytes) / Math.log(convertionValue),
    );
    return `${this.getFileSizeInMeasurement(
      this.loadedAmount,
      convertionIndex,
    )} / ${this.getFileSizeInMeasurement(bytes, convertionIndex)} ${
      this.sizes[convertionIndex]
    } Uploaded`;
  }
}
